// src/components/OrderRequirements/index.jsx
// ============================================================================
// BLOCK ORR.UI.0 — Order Requirements Route Wrapper
// Purpose:
//  - Export a single route component for AppContent.jsx
//  - Keep module isolated under /src/components/OrderRequirements
// ============================================================================

import React from 'react';

import OrderRequirements from './OrderRequirements.jsx';

export default function OrderRequirementsRoute() {
  return <OrderRequirements />;
}
